/**
 * @generated SignedSource<<398621db4b2a54980de464caed7fc2a1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BuildState = "deleted" | "finished" | "queued" | "running" | "unknown";
export type BuildArtifactsQuery$variables = {
  buildLocator: string;
};
export type BuildArtifactsQuery$data = {
  readonly build: {
    readonly artifacts: {
      readonly count: number | null | undefined;
    } | null | undefined;
    readonly id: number | null | undefined;
    readonly state: BuildState | null | undefined;
  } | null | undefined;
};
export type BuildArtifactsQuery = {
  response: BuildArtifactsQuery$data;
  variables: BuildArtifactsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "buildLocator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "buildLocator",
    "variableName": "buildLocator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Files",
  "kind": "LinkedField",
  "name": "artifacts",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "count",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BuildArtifactsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "build",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "BuildArtifactsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "build",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "_id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8fe8ff3c13a74615e1547cd0742d113c",
    "id": null,
    "metadata": {},
    "name": "BuildArtifactsQuery",
    "operationKind": "query",
    "text": "query BuildArtifactsQuery(\n  $buildLocator: String!\n) {\n  build(buildLocator: $buildLocator) {\n    id\n    state\n    artifacts {\n      count\n    }\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "d36e66a49626a2b31153f71771a3752e";

export default node;
